import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  alert,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  required,
  Pagination,
  Switch,
  Navbar,
  Modal,
  linkRole,
  copyText,
  CopyCell,
} from "../../components/CustomComponent.js";

// แสดง broker ที่ agent ดูแลเป็นชิป เกินจำนวนนี้ยุบเป็น +N แล้วเอาชื่อที่เหลือไปไว้ใน title
// กันไม่ให้แถวยืดจนตารางอ่านไม่ออกเมื่อ agent หนึ่งคนถือ broker หลายเจ้า
const BROKER_CHIP_LIMIT = 3;

const brokerName = (broker) =>
  broker.name_en || broker.name_th || broker.broker_code || "-";
const brokerNames = (brokers = []) => brokers.map(brokerName).join(", ");

// Gold-accented toggle to match the premium theme (same as the Users page).
const SWITCH_PROPS = {
  onColor: "#c9a23a",
  offColor: "#cbd5e1",
  onHandleColor: "#ffffff",
  checkedIcon: false,
  uncheckedIcon: false,
  height: 22,
  width: 42,
  handleDiameter: 16,
  activeBoxShadow: "0 0 0 3px rgba(212, 175, 55, 0.3)",
};

// ---------------------------------------------------------------------------
// Layout is new (shares the premium look of /su/users); the business logic
// (Get / CreateUpdate / Delete), state field names and API payloads are
// unchanged from the previous version of this page.
// ---------------------------------------------------------------------------
export default class Agents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      // modal แสดง broker ทั้งหมดของ agent ที่เลือก (เปิดจากชิป +N ในตาราง)
      modal_brokers: false,
      broker_agent: null,
      broker_search: "",

      filter_search: "",

      data: [],
      loaded: false,
      count: 10,

      id: "",
      uid: "",
      name_th: "",
      name_en: "",
      email: "",
      id_no: "",
      phone: "",
      is_active: true,
      password: "",
      deposit_commission_type: "",
      deposit_commission_value: "",
      withdrawal_commission_type: "",
      withdrawal_commission_value: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("v1/admin/agents", {
        page_size: 10,
        page: page,
        data_search: this.state.filter_search,
      })
    ]);
    if (result?.status) {
      data = result.data;
      count = result.pagination.count;
    }
    this.setState({
      data,
      count,
      loaded: true,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      uid,
      name_th,
      name_en,
      email,
      id_no,
      phone,
      is_active,
      password,
      modal_create,
    } = this.state;
    if (!name_th.trim()) {
      alert("", "warning", "Warning", "Please input Name TH");
      return;
    } else if (!name_en.trim()) {
      alert("", "warning", "Warning", "Please input Name EN");
      return;
    } else if (!email.trim()) {
      alert("", "warning", "Warning", "Please input Email");
      return;
    }

    if (modal_create) {
      if (!password) {
        alert("", "warning", "Warning", "Please input Password");
        return;
      }
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        name_th,
        name_en,
        email,
        id_no,
        phone,
        is_active,
        password,
      };

      let result = !uid
        ? await POST("v1/admin/agents", body)
        : await PUT("v1/admin/agents/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await DELETE("v1/admin/agents/" + id, null);
      if (result?.status === true) {
        alert("#", "success");
      }
      loading(false);
    }
  };

  // -------------------------------------------------------------------------
  // Render helpers (presentation only)
  // -------------------------------------------------------------------------
  openCreate = () => {
    this.setState({
      id: "",
      uid: "",
      name_th: "",
      name_en: "",
      email: "",
      id_no: "",
      phone: "",
      password: "",
      deposit_commission_type: "percentage",
      deposit_commission_value: "0",
      withdrawal_commission_type: "percentage",
      withdrawal_commission_value: "0",
      is_active: true,
      modal_create: true,
    });
  };
  openUpdate = (item) => {
    this.setState({ ...item, modal_update: true });
  };
  closeModal = () => {
    this.setState({ modal_create: false, modal_update: false });
  };
  openBrokers = (item) => {
    this.setState({ modal_brokers: true, broker_agent: item, broker_search: "" });
  };
  closeBrokers = () => {
    this.setState({ modal_brokers: false, broker_agent: null, broker_search: "" });
  };
  renderBrokers = (item) => {
    const brokers = item.brokers;
    if (!brokers?.length) {
      return <span className="pu-none">No broker assigned</span>;
    }
    const shown = brokers.slice(0, BROKER_CHIP_LIMIT);
    const rest = brokers.slice(BROKER_CHIP_LIMIT);
    return (
      <div className="pu-brokers">
        {shown.map((broker) => (
          <span
            key={broker.uid}
            className={`pu-broker-chip ${broker.is_active ? "" : "off"}`}
            title={broker.is_active ? "Active broker" : "Inactive broker"}
          >
            <span className="pu-broker-dot" />
            {brokerName(broker)}
          </span>
        ))}
        {rest.length > 0 && (
          <button
            type="button"
            className="pu-broker-chip more"
            title={`View all ${brokers.length} brokers`}
            onClick={() => this.openBrokers(item)}
          >
            +{rest.length}
          </button>
        )}
      </div>
    );
  };
  renderRow = (item, index) => {
    return (
      <tr key={item.uid || `array-${index}`}>
        <td data-label="Agent UID" className="text-nowrap">
          <div className="pu-uid" title={item.uid}>
            {item.uid ? (
              <CopyCell value={item.uid} label={item.uid.slice(0, 16) + "..."} className="pu-shq-ref" duration={2000} />
            ) : (
              <span className="pu-none">-</span>
            )}
          </div>
        </td>
        <td data-label="Name" className="text-nowrap">
          <div className="pu-user">
            <div className="min-w-0">
              <div
                className="pu-name text-truncate"
                title={item.name_en || item.name_th}
              >
                {item.name_en || item.name_th || "-"}
              </div>
              {item.name_en && item.name_th && (
                <div className="pu-sub">
                  <span className="text-truncate">{item.name_th}</span>
                </div>
              )}
              {item.phone && (
                <div className="pu-sub">
                  <span className="icon me-1">{""}</span>
                  {item.phone}
                </div>
              )}
            </div>
          </div>
        </td>
        <td data-label="Email" className="text-nowrap">
          <div className="pu-email" title={item.email}>
            {item.email ? <CopyCell value={item.email} className="pu-shq-ref" duration={2000} /> : <span className="pu-none">-</span>}
          </div>
        </td>
        <td data-label="Brokers">{this.renderBrokers(item)}</td>
        <td data-label="Status" className="text-nowrap text-center">
          <span className={`pr-status ${item.is_active ? "on" : "off"}`}>
            {item.is_active ? "Active" : "Inactive"}
          </span>
        </td>
        <td data-label="Actions" className="text-center agents.update td-actions">
          <Dropdown align="end">
            <Dropdown.Toggle className="pu-action-toggle" id={`agent-actions-${index}`}>
              Action
            </Dropdown.Toggle>
            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
            <Dropdown.Item
              className="pu-action-item agents.update"
              onClick={() => this.openUpdate(item)}
            >
              <span className="icon">{"\uf044"}</span>Update
            </Dropdown.Item>
            {!item.is_active && profile?.user_type === "super_user" && (
              <>
                <div className="pu-action-sep" />
                <Dropdown.Item
                  className="pu-action-item danger agents.delete"
                  onClick={() => this.Delete(item.uid)}
                >
                  <span className="icon">{"\uf1f8"}</span>Delete
                </Dropdown.Item>
              </>
            )}
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,
      loaded,
      count,
      name_th,
      name_en,
      email,
      id_no,
      is_active,
      password,
      modal_brokers,
      broker_agent,
      broker_search,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const allBrokers = broker_agent?.brokers || [];
    const activeBrokers = allBrokers.filter((b) => b.is_active).length;
    const q = broker_search.trim().toLowerCase();
    const brokerList = q
      ? allBrokers.filter((b) =>
          [b.name_en, b.name_th, b.broker_code]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
      : allBrokers;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Management</div>
                <div className="ar-title">Agent Management</div>
                <div className="ar-subtitle">
                  Manage agent accounts and the brokers they look after.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold agents.create"
                  onClick={this.openCreate}
                >
                  <span className="icon me-2">{""}</span>Create Agent
                </button>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{""}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field ar-filter-field-search">
<span className="ar-filter-label">Search</span>
<input
                type="text"
                className="form-control wpx-250"
                placeholder="Search name, email..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
</div>
<div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() =>
                  this.setState({ filter_search: "" }, () => this.Get(1))
                }
              >
                Reset
              </button>
              </div>
</div>
</div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Agents
                </div>
                <div className="ar-table-caption">
                  {count || 0} agent{count === 1 ? "" : "s"} · showing{" "}
                  {rows.length} on this page
                </div>
              </div>
              <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <span className="pu-legend-dot on" />
                  Active
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Inactive
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-200">Agent UID</td>
                    <td className="text-nowrap">Agent</td>
                    <td className="text-nowrap">Email</td>
                    <td className="text-nowrap">Brokers</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                    <td className="text-center text-nowrap agents.update td-actions">
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(this.renderRow)}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={6} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No agents found</div>
                          <div className="text-secondary text-14">
                            Try another search or create a new agent.
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New agent" : "Edit agent"}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : modal_update ? "Update" : ""} Agent
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {/* BASIC INFORMATION */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Basic Information
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Name TH{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="ชื่อภาษาไทย"
                    onChange={(e) => {
                      this.setState({ name_th: e.target.value });
                    }}
                    value={name_th}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Name EN{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="English name"
                    onChange={(e) => {
                      this.setState({ name_en: e.target.value });
                    }}
                    value={name_en}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Email{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="name@company.com"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                    disabled={modal_update}
                  />
                  {modal_update && (
                    <div className="pu-hint">
                      Email is the login identity and cannot be changed.
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">ID No.{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="National ID / passport no."
                    onChange={(e) => {
                      this.setState({ id_no: e.target.value });
                    }}
                    value={id_no}
                  />
                </div>
              </div>
            </div>

            {/* ACCOUNT INFORMATION */}
            {modal_create && (
              <div className="pu-section">
                <div className="pu-section-title">
                  <span className="icon">{""}</span>Account Information
                </div>
                <label className="pr-label">Password{required}</label>
                <div className="pu-password">
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Password"
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    value={password}
                  />
                  <button
                    type="button"
                    className="pu-generate"
                    title="Generate a random 12-character password"
                    onClick={() => {
                      const text = random_charactor(12);
                      this.setState({ password: text });
                    }}
                  >
                    <span className="icon me-2">{""}</span>Generate
                  </button>
                </div>
              </div>
            )}

            {/* STATUS */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Status
              </div>
              <label className={`pu-toggle ${is_active ? "on" : ""}`}>
                <span className="pu-toggle-icon icon">{""}</span>
                <span className="flex-grow-1 min-w-0">
                  <span className="pu-toggle-title">Active</span>
                  <span className="pu-toggle-desc">
                    Allow this agent to sign in and be assigned to brokers
                  </span>
                </span>
                <Switch
                  {...SWITCH_PROPS}
                  onChange={(e) => {
                    this.setState({ is_active: e });
                  }}
                  checked={is_active}
                />
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer justify-content-between">
            {modal_create ? (
              <button
                type="button"
                className="pu-copy-btn"
                title="Copy username and password"
                onClick={() => {
                  copyText(`username: ${email}
password: ${password}`);
                }}
              >
                <span className="icon me-2">{""}</span>Copy credentials
              </button>
            ) : (
              <span />
            )}
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1 rounded-pill"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                Submit
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                onClick={this.closeModal}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* ALL BROKERS OF ONE AGENT */}
        <Modal
          show={modal_brokers}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeBrokers}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Brokers</div>
              <h5 className="fw-bold mb-0">
                {broker_agent?.name_en || broker_agent?.name_th || "Agent"}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-broker-toolbar">
              <div className="pu-broker-summary">
                <span className="pu-broker-count">{brokerList.length}</span>
                <span>
                  {brokerList.length === 1 ? "broker" : "brokers"}
                  {broker_search.trim() && ` matching "${broker_search.trim()}"`}
                </span>
                <span className="pu-broker-sep" />
                <span className="pu-legend-dot on" />
                {activeBrokers} active
                <span className="pu-legend-dot off ms-3" />
                {allBrokers.length - activeBrokers} inactive
              </div>
              <input
                type="text"
                className="form-control pr-input wpx-250"
                placeholder="Search broker..."
                value={broker_search}
                onChange={(e) => this.setState({ broker_search: e.target.value })}
              />
            </div>
            <div className="pu-broker-list">
              {brokerList.length === 0 && (
                <div className="pr-empty">
                  <span className="icon">{"\uf1ad"}</span>
                  <div className="fw-bold">No broker found</div>
                </div>
              )}
              {brokerList.map((broker, i) => (
                <div
                  key={broker.uid || i}
                  className={`pu-broker-row ${broker.is_active ? "" : "off"}`}
                >
                  <div className="pu-broker-index">{i + 1}</div>
                  <div className="min-w-0 flex-grow-1">
                    <div className="pu-name text-truncate" title={brokerName(broker)}>
                      {brokerName(broker)}
                    </div>
                    <div className="pu-sub">
                      {broker.broker_code && (
                        <span className="pu-mono me-2">{broker.broker_code}</span>
                      )}
                      {broker.name_th && broker.name_en && (
                        <span className="text-truncate">{broker.name_th}</span>
                      )}
                    </div>
                  </div>
                  <span className={`pr-status ${broker.is_active ? "on" : "off"}`}>
                    {broker.is_active ? "Active" : "Inactive"}
                  </span>
                  <button
                    type="button"
                    className="pu-open-btn"
                    title="Open this broker in the Brokers page"
                    onClick={() => {
                      window.location.href = `/${linkRole(
                        profile?.user_type
                      )}/brokers?search=${encodeURIComponent(brokerName(broker))}`;
                    }}
                  >
                    <span className="pu-open-label">Open</span>
                    <span className="icon">{"\uf35d"}</span>
                  </button>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={this.closeBrokers}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
